import React from "react";
import { AlertTriangle, Bitcoin } from "lucide-react";

const videos = [
  {
    id: "iARZqID5-_E",
    title: "Video 1: How to set up Cash App and your Bitcoin wallet",
    caption: "How do I set up my bitcoin on Cash App",
  },
  {
    id: "v8mbVa__sWA",
    title: "Video 2: How do I buy Bitcoin",
    caption: "How do I buy Bitcoin on Cash App",
    note: "Remember, Bitcoin fluctuates. On your first try, buy $2–$5 more than your bill just in case for fees.",
  },
  {
    id: "yW_swlQvNio",
    title: "Video 3: How do I pay my bill with Bitcoin",
    caption: "How do I pay bill with bitcoin using Cash App",
  },
];

const HowToOrder = () => {
  return (
    <div className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="w-14 h-14 rounded-full bg-p3-gold/15 flex items-center justify-center mb-6">
          <Bitcoin size={26} className="text-p3-gold" />
        </div>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl text-p3-navy mb-5">
          How to Order &mdash; Bitcoin Payment Instructions
        </h1>

        <p className="text-sm text-p3-muted leading-relaxed mb-4">
          Please watch the videos below to learn how to buy and pay with Bitcoin. We want to give you a month
          or two to figure it out, then we will push for 3&ndash;12 months at a time so that you won&apos;t have
          to worry about it as often.
        </p>
        <p className="text-sm text-p3-muted leading-relaxed mb-10">
          We understand that many of you just refuse to mess with Bitcoin, and we understand, but unfortunately,
          due to those that get frustrated easily and file complaints with our payment companies instead of
          working with us &mdash; this is where we are.
        </p>

        <div className="space-y-10">
          {videos.map((v) => (
            <div key={v.id}>
              <h2 className="font-heading font-bold text-lg text-p3-navy mb-1">{v.title}</h2>
              <p className="text-sm text-p3-muted italic mb-3">{v.caption}</p>
              {v.note && (
                <p className="flex items-start gap-2 text-sm text-p3-navy bg-p3-cream rounded-lg p-3 mb-3">
                  <AlertTriangle size={16} className="text-p3-gold shrink-0 mt-0.5" /> {v.note}
                </p>
              )}
              <div className="rounded-2xl overflow-hidden shadow-lg aspect-video">
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${v.id}`}
                  title={v.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-p3-cream rounded-2xl p-6 space-y-3">
          <p className="text-sm text-p3-navy font-semibold">This is the simplest way we could make the instructions.</p>
          <p className="text-sm text-p3-muted leading-relaxed">
            If you can, do this on a computer so you can scan the QR code, or use two phones &mdash; one to take
            the picture and the one with Cash App to scan that picture. Otherwise, make sure you copy the entire
            wallet ID.
          </p>
          <p className="flex items-start gap-2 text-sm font-semibold text-red-600 bg-red-50 rounded-lg p-3">
            <AlertTriangle size={16} className="shrink-0 mt-0.5" /> If it is just 1 number off, THAT MONEY WILL BE
            GONE to who knows where.
          </p>
          <p className="text-sm text-p3-muted leading-relaxed">
            You only have to do this once &mdash; after that, you can save it as a contact.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HowToOrder;
